<template>
  <div class="app-header">
    <div class="header-left">
      <span class="module-title">{{ currentModuleName }}</span>
    </div>

    <div class="header-right">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link user-dropdown">
          <el-avatar size="small" icon="el-icon-user-solid"></el-avatar>
          <span class="user-name">{{ userName }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { menuCache } from '@/utils/menuCache'

export default {
  name: 'AppHeader',
  data() {
    return {
      userName: '管理员',
      currentModuleName: '数据中心'
    }
  },
  created() {
    const userInfoStr = localStorage.getItem('User-Info')
    if (userInfoStr) {
      try {
        const userInfo = JSON.parse(userInfoStr)
        if (userInfo && userInfo.name) {
          this.userName = userInfo.name
        }
      } catch (error) {
        console.error('解析用户信息失败', error)
      }
    }

    this.$root.$on('module-changed', name => {
      this.currentModuleName = name
    })
  },
  beforeDestroy() {
    this.$root.$off('module-changed')
  },
  methods: {
    handleCommand(command) {
      if (command === 'changePassword') {
        this.$message.info('开发中：触发修改密码功能')
        return
      }

      if (command !== 'logout') return

      this.$confirm('确定要退出登录吗？', '安全提示', {
        confirmButtonText: '确定退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/v1/logout').catch(() => {
          this.$message.warning('登录凭证已失效，已为你退出登录')
        }).finally(() => {
          localStorage.removeItem('Auth-Token')
          localStorage.removeItem('User-Info')
          menuCache.clear()
          window.location.replace(`${window.location.origin}${window.location.pathname}#/login`)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.app-header {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-bottom: 1px solid #f0f2f5;
}

.header-left {
  display: flex;
  align-items: center;
}

.module-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-dropdown {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #606266;
  transition: all 0.3s;
  padding: 2px 8px;
  border-radius: 4px;
}

.user-dropdown:hover {
  background-color: #f5f7fa;
}

.user-name {
  margin: 0 8px;
  font-size: 14px;
  font-weight: 500;
}
</style>
